import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { sortBy } from 'lodash-es';
import { getBootstrapCountriesSelector } from 'store/modules/bootstrap/selectors';
import SingleSelect, { ISingleSelectOption } from 'ui/SingleSelect';

export interface ICountrySelectProps {
  className?: string;
  value: string | null;
  labelWhenNothingSelected: string;
  onChange: (v: string | null) => void;
}

export const CountrySelect: React.FC<ICountrySelectProps> = (props) => {
  const rawCountries = useSelector(getBootstrapCountriesSelector);
  const countries = useMemo(() => sortBy(rawCountries, 'name'), [rawCountries]);
  const countryOptions: ISingleSelectOption[] = useMemo(
    () => countries.map(c => ({ value: c.code, label: c.name })),
    [countries]
  );

  const handleChange = useCallback(
    (value?: string) => props.onChange(value ?? null),
    [props.onChange]
  );
  
  return (
    <SingleSelect
      fieldId="filterCountry"
      className={props.className}
      value={props.value ?? undefined}
      options={countryOptions}
      onChange={handleChange}
      maxVisibleItems={6}
      showSelectedOption
      labelWhenNothingSelected={props.labelWhenNothingSelected}
      useCustomLabelWhenNothingSelected
    />
  );
};
